import React from 'react';
import {FormControl} from 'react-bootstrap';

const ConditionDetailsInput = (props) => {
  const {Details = ''} = props.screensData;
  return <div>
    <div className="font-size-17   top20 text-left set-width align-center text-bold">{' Condition Details:'}</div>
    <div className="top5 align-center set-width">
      <FormControl
        data-testid='condition-details-input'
        value={Details}
        componentClass="textarea"
        rows="1"
        placeholder=""
        onChange={(e) => props.setScreensData({
          Details: e.target.value,
        })}
        type="text"/>
    </div>
  </div>;
};

export default ConditionDetailsInput;